<template>
  <div>
    <transition name="fade" mode="out-in">
      <div class="loading" v-if="upload">
        <div class="label">
          <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
          <br />
          {{ message }}
        </div>
      </div>
    </transition>
    <div class="header-intervention">
      <div
        class="header-info"
        v-if="intervention.pm !== undefined && start"
      >{{index + 1}}</div>
      <div class="button-content" v-if="intervention.pm !== undefined">
        <b-button class="button" v-if="photoBefore" @click="startDebrief">
          <i class="fa fa-pencil-square-o"></i> Continuer
        </b-button>
        <b-button class="button" v-if="index > 0 && (start || finalized)" @click="previousPosition">
          <i class="fa fa-chevron-left" aria-hidden="true"></i> Précédent
        </b-button>
        <b-button :disabled="!isFormValid" class="button" v-if="showNextButton && start" @click="nextPosition()">Suivant <i class="fa fa-chevron-right" aria-hidden="true"></i></b-button>
        <b-button
          :disabled="intervention.pm.some(pos => pos.selected && !pos.complete)"
          v-if="(index >= (positionsWithTech.length - 1) && (index <= positionsWithTech.length + positionsWithoutTech.length - 1)) && start"
          class="button"
          @click="openConfirmModal()"
        >
          Clôturer
          <i class="fa fa-camera" aria-hidden="true"></i>
        </b-button>
        <b-button class="button" v-if="photoAfter" @click="end">
          <div class="fa fa-paper-plane"></div>Envoyer
        </b-button>
      </div>
    </div>
    <b-container class="photo-content" v-show="photoBefore || photoAfter">
      <div class="photo">
        <div class="photo-placeholder" v-if="intervention.files !== undefined && intervention.files.length === 0">Ajouter une photo du PM avant intervention</div>
        <div class="picture" v-for="(file, index) in intervention.files" :key="index">
          <div class="label">{{file.description}}</div>
          <img class="preview" v-bind:src="file.image" alt />
          <div class="options">
            <div class="rename" v-on:click="rename(file)">Renommer</div>
            <div class="delete" v-on:click="deleteFile(file)">Supprimer</div>
          </div>
        </div>
        <div class="buttonPhoto" v-on:click="selectPicture">
          <i class="fa fa-camera" aria-hidden="true"></i> Ajouter des photos
        </div>
        <input ref="fileInput" type="file" accept="image/*" @change="onFileChange" multiple />
      </div>
    </b-container>
    <b-container class="debrief-content" v-show="start">
      <div style="margin-bottom: 2rem;">
        <div style="display: flex; justify-content: space-between; margin-bottom: 1rem;">
          <b-button
            class="button"
            v-if="isCurrentPositionWithoutTech"
            @click="cancelNewPosition()">
            Annuler
          </b-button>
          <b-button
            :disabled="!isFormValid || positionsWithoutTech.some(pos => pos.item.selected && !pos.item.complete)"
            class="button"
            v-if="positionsWithoutTech.length && start && positionsWithoutTech.some(pos => !pos.item.selected) && index >= positionsWithTech.length - 1"
            @click="showNewPositions"
            style="margin-left: auto"
          >
            Ajouter
          </b-button>
        </div>
        <div><b>Positions obligatoires: </b>{{ positionsWithTech.length }}</div>
        <div><b>Positions optionnelles: </b> {{ positionsWithoutTech.length }}</div>
        <div><b>Positions traitées: </b> {{ intervention.pm !== undefined && intervention.pm.filter(pos => pos.complete).length }}</div>
        <hr class="divider">
      </div>
      <div v-if="intervention.pm !== undefined && intervention.pm[index] !== undefined">
        <div class="line"><span class="label">OC : </span> {{intervention.pm[index].rop.fo.oc1.oc}}</div>
        <div class="line"><span class="label">OI : </span> {{intervention.pm[index].operateur}}</div>
        <div class="line" v-if="intervention.pm[index].oc !== undefined"><span class="label">Connecteur opérateur tier (porte gauche): </span> {{`${intervention.pm[index].oc.nom_module_pm} ${intervention.pm[index].oc.position_module_pm}` }}</div>
        <div class="line" v-else><span class="label">Connecteur opérateur tier (porte gauche): </span>Non défini</div>
        <div class="line"><span class="label">Position coupleur FREE (porte gauche): </span> {{ !intervention.pm[index].adduction || !intervention.pm[index].adduction.pm.position_coupleur ? 'Non défini' : intervention.pm[index].adduction.pm.position_coupleur }}</div>
        <div class="line"><span class="label">Coupleur optique : </span> {{ !intervention.pm[index].adduction || !intervention.pm[index].adduction.pm.coupleur ? 'Non défini' : intervention.pm[index].adduction.pm.coupleur }}</div>
        <div class="line"><span class="label">Fibre backbone : </span> {{`${intervention.pm[index].adduction.cable.nom} tube ${intervention.pm[index].adduction.cable.couleur_tube} bague(s) ${intervention.pm[index].adduction.cable.bague_tube} fibre ${intervention.pm[index].adduction.cable.couleur_fibre}`}}</div>
      </div>
      <div class="content-arbre">
        <div v-for="(question, questionKey) in debrief" :key="questionKey" class="content debrief">
          <div class="question" :data-required="question.required" :data-question-id="question.question_id">
            <div class="label">
              {{ question.question_label }}
              <div class="required" v-if="question.required">( Réponse obligatoire )</div>
            </div>
            <div v-for="(response, responseKey) in question.reponse" :key="responseKey">
              <div
                class="reponse-button action"
                :class="{ check: isChecked(question.question_id, response.reponse_id) }"
                :data-question-id="question.question_id"
                :data-reponse-id="response.reponse_id"
                @click="handleResponseClick(question.question_id, response.reponse_id)"
              >
                <i class="fa fa-check" :class="{ hide: !isChecked(question.question_id, response.reponse_id) }" aria-hidden="true"></i>
                {{ response.reponse_label }}
              </div>
              <div v-if="response.next_question" class="child" :class="['next_question_' + response.reponse_id, { hide: !isChecked(question.question_id, response.reponse_id) }]">
                <ArbreRecursive
                  :debrief="debrief"
                  :question="question"
                  :response="response"
                  :data="response.next_question"
                  :index="index"
                  :intervention="intervention"
                  :requiredResponses="requiredResponses"
                />
              </div>
            </div>
            <div v-if="question.custom_response" class="reponse-input" :data-question-id="question.question_id">
              <input type="text" placeholder="Votre réponse" @input="updateCustomResponse(question.question_id, $event.target.value)" />
            </div>
          </div>
        </div>
      </div>
      <div class="bulle" @click="stopAudit">
        <i class="fa fa-stop"></i>
      </div>
    </b-container>
    <modal name="new-positions" class="new-positions" height="auto" :width="modalWidth" :resizable="true" :scrollable="true">
      <div class="modal-header">
        <h4 class="modal-title">Positions</h4>
        <i class="fa fa-times" @click="closingModal"></i>
      </div>
      <div class="modal-body">
        <div v-for="(position, i) in positionsWithoutTech" :key="i">
          <div v-if="!position.item.selected" style="margin-bottom: 2rem;">
            <div class="line"><span class="label">OC : </span> {{position.item.rop.fo.oc1.oc}}</div>
            <div class="line"><span class="label">OI : </span> {{position.item.operateur}}</div>
            <div class="line" v-if="position.oc !== undefined"><span class="label">Connecteur opérateur tier (porte gauche): </span> {{`${position.item.oc.nom_module_pm} ${position.item.oc.position_module_pm}` }}</div>
            <div class="line" v-else><span class="label">Connecteur opérateur tier (porte gauche): </span>Non défini</div>
            <div class="line"><span class="label">Position coupleur FREE (porte gauche): </span> {{ !position.item.adduction || !position.item.adduction.pm.position_coupleur ? 'Non défini' : position.item.adduction.pm.position_coupleur }}</div>
            <div class="line"><span class="label">Coupleur optique : </span> {{ !position.item.adduction || !position.item.adduction.pm.coupleur ? 'Non défini' : position.item.adduction.pm.coupleur }}</div>
            <div class="line"><span class="label">Fibre backbone : </span> {{`${position.item.adduction.cable.nom} tube ${position.item.adduction.cable.couleur_tube} bague(s) ${position.item.adduction.cable.bague_tube} fibre ${position.item.adduction.cable.couleur_fibre}`}}</div>
            <b-button class="button" v-if="start" @click="nextPosition(position.index)">Sélectionner</b-button>
            <hr v-if="positionsWithoutTech.length - 1 > i || positionsWithoutTech.some(pos => pos.item.selected).length > 1" class="divider">
          </div>
        </div>
      </div>
    </modal>
    <modal name="confirmation" height="auto" :width="modalWidth">
      <div class="modal-header">
        <h4 class="modal-title">Attention</h4>
      </div>
      <div class="modal-body">
        <p>Vous étes sur le point de valider le debriefing. Êtes-vous sur de vouloir terminer l'intervention?</p>
      </div>
      <div class="modal-footer">
        <b-button class="button" variant="outline-danger" @click="$modal.hide('confirmation')">Annuler</b-button>
        <b-button class="button" variant="danger" @click="finalize">Confirmer</b-button>
      </div>
    </modal>
  </div>
</template>

<script>
import ArbreRecursive from './ArbreRecursive.vue'
export default {
  components: {ArbreRecursive},
  data () {
    return {
      intervention_id: null,
      intervention: {},
      upload: false,
      message: '',
      waiting: {
        position: 0,
        total: 0
      },
      photoBefore: false,
      start: false,
      finalized: false,
      confirmReponses: false,
      photoAfter: false,
      index: 0,
      debrief: [],
      positionsWithTech: [],
      positionsWithoutTech: [],
      requiredResponses: [],
      selectedPositions: []
    }
  },
  watch: {
    requiredResponses: {
      handler (newVal) {
        this.handleFormValidationChange(this.isFormValid)
      },
      deep: true
    },
    'intervention.pm': {
      handler (newVal) {
        this.updatePositions()
      }
    }
  },
  computed: {
    showNextButton () {
      if (this.index < (this.positionsWithTech.length - 1)) return true

      const lastIndexSelected = this.intervention.pm.reduce((acc, pm, idx) => {
        return pm.selected || pm.complete ? idx : acc
      }, -1)

      return this.index < lastIndexSelected
    },
    isFormValid () {
      return this.requiredResponses.every(e => e.answered === true)
    },
    isCurrentPositionWithoutTech () {
      return this.positionsWithoutTech.some((e) => e.index === this.index)
    },
    modalWidth () {
      if (window.innerWidth < 768) {
        return '90%'
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        return '70%'
      } else {
        return '50%'
      }
    }
  },
  methods: {
    handleFormValidationChange (isValid) {
      if (isValid) {
        this.intervention.pm[this.index]['complete'] = true
      }
    },
    closingModal () {
      this.$modal.hide('new-positions')
    },
    showNewPositions () {
      this.$modal.show('new-positions')
    },
    cancelNewPosition () {
      this.intervention.pm[this.index].reponses = []
      this.intervention.pm[this.index]['complete'] = false
      this.intervention.pm[this.index]['selected'] = false
      this.previousPosition()
    },
    isChecked (questionId, responseId) {
      if (!this.intervention.pm || !this.intervention.pm[this.index] || !this.intervention.pm[this.index].reponses) {
        return false
      }
      return this.intervention.pm[this.index].reponses.some((r) => parseInt(r.question_id) === questionId && parseInt(r.reponse_id) === responseId)
    },
    handleResponseClick (questionId, responseId) {
      const responses = this.intervention.pm[this.index].reponses

      const existingResponseIndex = responses.findIndex(
        (r) => parseInt(r.question_id) === questionId
      )
      if (existingResponseIndex !== -1) {
        this.resetDependantValues(questionId)

        this.$delete(responses, existingResponseIndex)
      }
      this.$set(responses, responses.length, { question_id: questionId, reponse_id: responseId })

      const requiredResponseIndex = this.requiredResponses.findIndex(r => r.index === questionId)
      if (requiredResponseIndex !== -1) {
        this.$set(this.requiredResponses, requiredResponseIndex, { index: questionId, answered: true })

        const response = Object.values(this.debrief).find(r => r.question_id === questionId).reponse
        const nextQuestion = Object.values(response).find(r => r.reponse_id === responseId).next_question

        if (nextQuestion) {
          Object.values(this.debrief).forEach((question) => {
            if (question.required) {
              this.$set(this.requiredResponses, requiredResponseIndex, { index: questionId, answered: false })
            }
          })
        }
      }

      this.$forceUpdate()
    },
    resetDependantValues (parentQuestion) {
      const questions = Object.values(this.debrief).find(r => r.question_id === parentQuestion).reponse
      const responses = this.intervention.pm[this.index].reponses

      Object.values(questions).forEach((r) => {
        if (r.next_question) {
          Object.values(r.next_question).forEach((nexQuestion) => {
            const responseIndex = responses.findIndex((r) => parseInt(r.question_id) === nexQuestion.question_id)

            if (responseIndex !== -1) {
              this.$delete(responses, responseIndex)
            }
          })
        }
      })
    },
    setRequiredResponses (currentResponses) {
      const responses = []
      Object.values(this.debrief).forEach((question) => {
        if (question.required) {
          const answered = currentResponses.some(response => parseInt(response.question_id) === question.question_id)
          responses.push({ index: question.question_id, answered })
        }
      })

      return responses
    },
    end: function () {
      if (this.intervention.files.length < 2) {
        this.$toast.bottom('Veuillez prendre une photo du PM avant et après intervention')
        return false
      }
      this.uploadPicture()
    },
    openConfirmModal () {
      if (!this.isFormValid) {
        this.$toast.bottom('Vous n\'avez pas fini de renseigner cette position')
        return false
      }

      if (!this.confirmReponses) {
        return this.$modal.show('confirmation')
      }
    },
    finalize: function () {
      this.$modal.hide('confirmation')
      this.saveReponses()
      this.start = false
      this.finalized = true
      this.photoAfter = true
    },
    selectPicture: function () {
      this.$refs.fileInput.click()
    },
    uploadPicture: function () {
      if (this.waiting.position >= this.intervention.files.length) {
        this.upload = false
        this.waiting.position = 0
        this.waiting.total = 0
        this.intervention.files.length = 0
        this.send()
      } else {
        this.upload = true
        this.waiting.total = this.intervention.files.length
        this.message = 'Upload ' + this.waiting.position + '/' + this.waiting.total
        this.uploadPictureServer(this.intervention.files[this.waiting.position])
      }
    },
    uploadPictureServer: function (data) {
      this.$http.post('intervention/' + this.intervention_id + '/photo', JSON.stringify(data)).then(response => {
        this.response = response.json().then((data) => {
          this.waiting.position++
          this.uploadPicture()
        })
      }, (response) => {
        console.log(response)
      })
    },
    rename: function (file) {
      file.description = prompt('Nommer la photo', file.description)
      this.$setItem(this.intervention_id, this.intervention, (err) => {
        if (err) alert(err)
      })
      this.$forceUpdate()
    },
    deleteFile: function (file) {
      let i = this.intervention.files.indexOf(file)
      if (i !== -1) {
        this.intervention.files.splice(i, 1)
      }
    },
    onFileChange: function (e, prefill) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      let _this = this
      for (let i in files) {
        let file = files[i]

        if (!(file instanceof File)) {
          continue
        }
        let reader = new FileReader()
        reader.onload = function (e) {
          let image = new Image()
          image.src = e.target.result
          image.onload = function () {
            let maxWidth = 1024
            let maxHeight = 768
            let imageWidth = image.width
            let imageHeight = image.height

            if (imageWidth > imageHeight) {
              if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth
                imageWidth = maxWidth
              }
            } else {
              if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight
                imageHeight = maxHeight
              }
            }
            let canvas = document.createElement('canvas')
            canvas.width = imageWidth
            canvas.height = imageHeight
            image.width = imageWidth
            image.height = imageHeight
            let ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, imageWidth, imageHeight)
            _this.intervention.files.push({
              image: canvas.toDataURL(file.type).replace('jpeg', 'jpg').replace('png', 'jpg'),
              description: file.name.replace('.jpeg', '').replace('.jpg', '').replace('.png', '')
            })
            _this.$forceUpdate()
            _this.$setItem(_this.intervention_id, _this.intervention, (err) => {
              if (err) alert(err)
            })
          }
        }
        reader.readAsDataURL(file)
      }
    },
    previousPosition: function () {
      if (this.finalized) {
        this.photoAfter = false
        this.photoBefore = false
        this.start = true
        this.finalized = false
        let position = this.intervention.pm.findIndex(pm => pm.complete === undefined || pm.complete === false) - 1
        this.$set(this.intervention.pm[position], 'selected', true)
        return this.setCurrentPosition(position)
      }

      const previousIndex = this.intervention.pm.slice(0, this.index).reverse().findIndex(pm => pm.selected)

      if (previousIndex !== -1) {
        this.setCurrentPosition(this.index - previousIndex - 1)
      }
    },
    nextPosition (index = null) {
      if (!this.isFormValid) {
        return this.$toast.bottom('Vous n\'avez pas fini de renseigner cette position')
      }

      this.saveReponses()

      // "Ajouter" modal
      if (index) {
        this.$modal.hide('new-positions')
        this.$set(this.intervention.pm[index], 'selected', true)
        return this.setCurrentPosition(index)
      }

      // "Suivant" position obligatoire
      if (this.index < this.positionsWithTech.length - 1) {
        this.$set(this.intervention.pm[this.index + 1], 'selected', true)
        return this.setCurrentPosition(this.index + 1)
      }

      // "Suivant" position optionnelle
      const nextWithoutTechIndex = this.positionsWithoutTech.find((pos) => pos.index > this.index && pos.item.selected)
      if (nextWithoutTechIndex) {
        this.$set(this.intervention.pm[nextWithoutTechIndex.index], 'selected', true)
        return this.setCurrentPosition(nextWithoutTechIndex.index)
      }
    },
    setCurrentPosition: function (position = 0) {
      this.index = position
      let currentPosition = this.intervention.pm[position]
      if (currentPosition.reponses === undefined) currentPosition.reponses = []
      if (currentPosition.rop !== undefined && currentPosition.rop && currentPosition.rop.fo !== undefined && currentPosition.rop.fo) {
        const operateurs = [currentPosition.rop.fo.oc1, currentPosition.rop.fo.oc2, currentPosition.rop.fo.oc3, currentPosition.rop.fo.oc4]
        this.intervention.pm[position].oc = operateurs.find(o => o.oc === 'FREE' || o.oc === 'IFTR')
      }

      this.requiredResponses = this.setRequiredResponses(currentPosition.reponses)
    },
    saveReponses () {
      let checked = document.getElementsByClassName('check')
      this.intervention.pm[this.index]['reponses'] = []
      for (let e of checked) {
        this.intervention.pm[this.index]['reponses'].push({cmd_id: this.intervention.pm[this.index].ref_oc, question_id: e['attributes']['data-question-id']['value'], reponse_id: e['attributes']['data-reponse-id']['value']})
      }
      this.$setItem(this.intervention_id, this.intervention, (err) => {
        if (err) alert(err)
      })
    },
    send () {
      let debrief = []
      let b
      for (let i in this.intervention.pm) {
        b = 0
        if (this.intervention.pm[i].reponses === undefined || this.intervention.pm[i].reponses === null) continue
        while (b < this.intervention.pm[i].reponses.length) {
          debrief.push(this.intervention.pm[i].reponses[b])
          b++
        }
      }
      let data = {debrief: debrief}
      this.$http.post('intervention/' + this.intervention_id + '/action/debrief', JSON.stringify(data)).then(response => {
        this.$removeItem(this.intervention_id)
        this.$router.push('/intervention/' + this.intervention_id)

        if (response.status !== 200) {
          return this.$toast(response.body && response.body.error ? response.body.error : 'Une erreur est survenue lors de l\'enregistrement du debrief')
        }
        return this.$toast.bottom('Intervention terminée')
      }).catch(err => {
        return this.$toast(err || 'Une erreur est survenue')
      })
    },
    startDebrief: function () {
      if (!this.intervention.files[0]) {
        this.$toast.bottom('Veuillez prendre une photo du pm avant intervention')
        return false
      }
      this.photoBefore = false
      this.start = true
      this.finalized = false
      let position = this.intervention.pm.findIndex(pm => pm.complete === undefined || pm.complete === false)
      if (position === -1) position = this.intervention.pm.length - 1
      this.$set(this.intervention.pm[position], 'selected', true)
      this.setCurrentPosition(position)
    },
    stopAudit: function () {
      if (confirm('Etes vous sûr de vouloir terminer l\'intervention tout de suite ? Il vous reste des positions à auditer.')) {
        if (this.isFormValid) this.saveReponses()
        this.start = false
        this.photoAfter = true
      }
    },
    updatePositions () {
      const interventionPmWithIndices = this.intervention.pm.map((item, index) => ({ item, index }))
      this.positionsWithTech = interventionPmWithIndices.filter(e => e.item.tech_id)
      this.positionsWithoutTech = interventionPmWithIndices.filter(e => !e.item.tech_id)
    }
  },
  created () {
    this.intervention_id = this.$route.params.intervention_id
    this.debrief = JSON.parse(localStorage.getItem('debrief_' + this.intervention_id))
    this.$getItem(this.intervention_id, (err, values) => {
      if (err) {
        return
      }
      this.intervention = values
      if ((this.intervention.dateFin !== '00-00-00 00:00:00' && this.intervention.dateFin !== null) || values.pm === undefined || values.pm === null) {
        this.$router.push('/intervention/' + this.intervention_id)
      }
      if (this.intervention.files === undefined) this.intervention.files = []
      this.photoBefore = true
    })
  }
}
</script>
<style>
.content.debrief {
  position: relative;
  background: #ffffff;
  margin-bottom: 10px;
  width: 100%;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.4);
  color: #444;
  background-repeat: no-repeat;
  background-position: bottom 5px right 10px;
  background-size: 15%;
  padding: 10px 10px 10px;
  border-top: 2px solid rgb(230, 68, 68) !important;
  border-radius: 3px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.content.sub {
  border-top: none !important;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-left: 3%;
  margin-top: 20px;
  width: calc(100% - 3%);
  border-left: 2px solid rgb(230, 68, 68) !important;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
}
.reponse-input {
  margin-left: auto;
  margin-right: auto;
}
.reponse-input > input {
  text-align: center;
  padding: 0.48rem 0.75rem;
  font-size: 1rem;
  line-height: 1;
  color: #464a4c;
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  display: inherit;
  background-color: #fff;
  background-image: none;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
}
#signature-pad {
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2) inset;
  width: 90%;
  height: 40%;
  margin-top: 10px;
}
.signature {
  position: fixed;
  text-align: center;
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  color: #444;
}
.rules {
  font-size: 14px;
}
.required {
  color: green;
  font-size: 13px;
}
.hide {
  display: none;
}
.action.check {
  border: 1px solid green !important;
  color: white;
  background-color: green;
}
.question > .label {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}
.reponse-button {
  color: rgb(230, 68, 68);
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  border: 1px solid rgb(230, 68, 68) !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-radius: 0.2rem;
  padding: 0.5rem 0.5rem;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 5px;
  cursor: pointer;
}
.line > .label {
  font-weight: 700;
}
</style>
<style scoped>
.header-info {
  display: inline-block;
  position: absolute;
  left: 12px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  top: 71px;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
  text-align: center;
}
.button-content {
  position: absolute;
  right: 12px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  top: 71px;
}
  .button-content > button, .new-positions button, .debrief-content button {
    display: inline-block;
    background-color: rgb(230, 68, 68) !important;
    border-color: rgb(230, 68, 68) !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border-radius: 0.2rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    line-height: 1.5;
    cursor: pointer;
  }
  .button-content > button {
    margin-left: 10px;
  }
  .new-positions button {
    margin-top: 1.5rem;
  }
  .debrief-content, .photo-content {
    margin-top: 110px;
    padding-top: 30px;
  }
.loading {
  position: fixed;
  text-align: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  color: white;
  top: 55px;
}
.loading > .label {
  padding-top: 35vh;
}
.title-selector {
  text-align: center;
  padding-top: 6px;
}
.select {
  margin-left: 5px;
}
.photo-placeholder {
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: xx-large;
    color: #949493;
}
.picture {
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  width: 44vw;
  padding: 10px;
  margin-left: 2vw;
  margin-bottom: 2vh;
}
.picture > .label {
  text-align: center;
  margin-bottom: 10px;
}
.picture > .options {
  text-align: center;
}
.picture > .options > div {
  text-align: center;
  background-color: rgb(230, 68, 68);
  margin-top: 5px;
  font-size: 14px;
  padding: 5px;
  color: white;
}
.buttonPhoto {
  height: 50px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  border: 1px solid rgb(230, 68, 68);
  width: 97%;
  margin-right: 4px;
  margin-left: auto;
  text-align: center;
  background-color: white;
  color: rgb(230, 68, 68);
  border-radius: 4px;
  margin-bottom: 8px;
}
.buttonPhoto .fa {
  font-size: 15px;
  margin-top: 18px;
}
input[type="file"] {
  display: none;
}
.preview {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.loading {
  position: fixed;
  text-align: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  color: white;
  top: 55px;
}
.loading > .label {
  padding-top: 35vh;
}
.bulle {
  height: 45px;
  width: 45px;
  background-color: #e64444;
  border-radius: 50%;
  line-height: 45px;
  text-align: center;
  color: white;
  position: fixed;
  right: 15px;
  bottom: 15px;
}
.divider {
  position: absolute;
  left: 0;
  right: 0;
  background-color: black;
  opacity: 0.4;
}
.fa-times {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AuditPM.vue